import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCta() {
  return <section data-section-id="256040" id="צרו-קשר" className="bg-background text-foreground py-20 md:py-28">
      <div className="page-container text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-primary mb-6">
            זקוקים למטפל סיעודי באופן מיידי?
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground mb-10">
            אל תשארו לבד ברגעים המורכבים. אנחנו כאן כדי לספק לכם מענה מקצועי, אנושי ומהיר תוך 5 שעות בלבד, כדי שיקירכם יקבלו את הטיפול הטוב ביותר.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground border-none h-14 px-8 text-base w-full sm:w-auto rounded-lg shadow-lg">
              <Link to="/ContactPage">ייעוץ ראשוני חינם</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-accent hover:text-accent-foreground h-14 px-8 text-base w-full sm:w-auto bg-transparent rounded-lg">
              <Link to="tel:0500000000">התקשרו עכשיו</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}